




















import Vue from 'vue';
export default Vue.extend({
  methods: {
    back() {
      this.$router.back();
    }
  }
});
